/* Motus Sounds Theme JS — v2.0 */
(function () {
  'use strict';

  // ── Cart Drawer ──────────────────────────────────────────────────────────────
  var cartToggle  = document.getElementById('motus-cart-toggle');
  var cartClose   = document.getElementById('motus-cart-close');
  var cartDrawer  = document.getElementById('motus-cart-drawer');
  var cartOverlay = document.getElementById('motus-cart-overlay');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('motus-cart-drawer--open');
    cartOverlay.classList.add('motus-cart-overlay--open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('motus-cart-drawer--open');
    cartOverlay.classList.remove('motus-cart-overlay--open');
    document.body.style.overflow = '';
  }

  if (cartToggle)  cartToggle.addEventListener('click', openCart);
  if (cartClose)   cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // ── Mobile Menu ──────────────────────────────────────────────────────────────
  var hamburger  = document.getElementById('motus-hamburger');
  var mobileMenu = document.getElementById('motus-mobile-menu');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      mobileMenu.classList.toggle('motus-nav__mobile--open');
    });
  }

  // ── AJAX Add to Cart ─────────────────────────────────────────────────────────
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList.contains('motus-product-form')) return;
    e.preventDefault();

    var btn = form.querySelector('[name="add"]');
    if (!btn) return;
    var originalText = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;

    var formData = new FormData(form);
    var data = { id: formData.get('id'), quantity: 1 };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    })
    .then(function (res) { return res.json(); })
    .then(function () {
      btn.textContent = 'Added!';
      btn.style.background = 'linear-gradient(135deg, #059669, #047857)';
      updateCartCount();
      setTimeout(function () {
        openCart();
        btn.textContent = originalText;
        btn.style.background = '';
        btn.disabled = false;
      }, 800);
    })
    .catch(function () {
      btn.textContent = 'Error — Try Again';
      btn.disabled = false;
      setTimeout(function () { btn.textContent = originalText; }, 2000);
    });
  });

  // ── Update Cart Count ────────────────────────────────────────────────────────
  function updateCartCount() {
    fetch('/cart.js')
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      var countEl = document.getElementById('motus-cart-count');
      if (countEl) countEl.textContent = cart.item_count;
    })
    .catch(function () {});
  }

  // ── Announcement Bar Close ───────────────────────────────────────────────────
  var annBar   = document.getElementById('motus-ann-bar');
  var annClose = document.getElementById('motus-ann-close');
  if (annBar && annClose) {
    if (sessionStorage.getItem('motus-ann-closed')) annBar.style.display = 'none';
    annClose.addEventListener('click', function () {
      annBar.style.display = 'none';
      sessionStorage.setItem('motus-ann-closed', '1');
    });
  }

  // ── Smooth scroll for anchor links ──────────────────────────────────────────
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (mobileMenu) mobileMenu.classList.remove('motus-nav__mobile--open');
      }
    });
  });

  // ── Toast Notification ───────────────────────────────────────────────────────
  window.motusShowToast = function (msg) {
    var toast    = document.getElementById('motus-toast');
    var toastMsg = document.getElementById('motus-toast-msg');
    if (!toast) return;
    toastMsg.textContent = msg;
    toast.classList.remove('motus-toast--hidden');
    setTimeout(function () {
      toast.classList.add('motus-toast--hidden');
    }, 4000);
  };

  // ── Entry CTA Popup Modal ────────────────────────────────────────────────────
  window.motusCloseModal = function () {
    var modal = document.getElementById('motus-cta-modal');
    var box   = document.getElementById('motus-cta-box');
    if (!modal) return;
    modal.style.opacity = '0';
    box.style.transform = 'scale(0.95)';
    setTimeout(function () { modal.style.display = 'none'; }, 300);
  };

  function motusShowModal() {
    var modal = document.getElementById('motus-cta-modal');
    var box   = document.getElementById('motus-cta-box');
    if (!modal) return;
    modal.style.display = 'flex';
    modal.style.opacity = '0';
    box.style.transform = 'scale(0.95)';
    setTimeout(function () {
      modal.style.opacity = '1';
      box.style.transform = 'scale(1)';
    }, 10);
  }

  // Trigger popup 2.2s after page load for first-time visitors
  if (!localStorage.getItem('motus_subscribed')) {
    setTimeout(motusShowModal, 2200);
  }

  // Close modal when clicking the overlay backdrop
  document.addEventListener('click', function (e) {
    var modal = document.getElementById('motus-cta-modal');
    if (modal && e.target === modal) {
      window.motusCloseModal();
    }
  });

  // Modal form submit
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.id || form.id !== 'motus-modal-form') return;
    e.preventDefault();
    localStorage.setItem('motus_subscribed', 'true');
    window.motusCloseModal();
    window.motusShowToast('Starter Vault Unlocked! Download link sent to your inbox.');
  });

  // Section free-pack form submit
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.id || form.id !== 'motus-section-form') return;
    e.preventDefault();
    localStorage.setItem('motus_subscribed', 'true');
    window.motusShowToast('Access Granted! Check your email inbox now.');
  });

  // ── Web Audio Procedural Sample Preview Engine ───────────────────────────────
  var audioCtx = null;
  var currentPlayingTrack = null;
  var previewInterval = null;

  var TRACK_PREVIEWS = {
    'hero':  { bpm: 124, type: 'cyberpunk' },
    'card0': { bpm: 140, type: 'trap' },
    'card1': { bpm: 120, type: 'synthwave' },
    'card2': { bpm: 130, type: 'drums' },
    'card3': { bpm: 128, type: 'trap' },
    'card4': { bpm: 115, type: 'synthwave' },
    'card5': { bpm: 135, type: 'cyberpunk' }
  };

  function initAudio() {
    if (!audioCtx) {
      audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    }
    if (audioCtx.state === 'suspended') audioCtx.resume();
  }

  window.motusTogglePreview = function (trackId, btnId, waveId) {
    initAudio();
    if (currentPlayingTrack === trackId) {
      stopAudioPreview();
      return;
    }
    if (currentPlayingTrack) stopAudioPreview();
    currentPlayingTrack = trackId;
    updatePreviewUI(trackId, btnId, waveId, true);
    playProceduralPreview(trackId);
  };

  function stopAudioPreview() {
    if (previewInterval) { clearInterval(previewInterval); previewInterval = null; }
    if (currentPlayingTrack) {
      var tid = currentPlayingTrack;
      currentPlayingTrack = null;
      updatePreviewUI(tid, tid + '-btn', tid + '-wave', false);
    }
  }

  function updatePreviewUI(trackId, btnId, waveId, isPlaying) {
    var btn     = document.getElementById(btnId);
    var btnTxt  = document.getElementById(trackId + '-btn-text');
    var wave    = document.getElementById(waveId);
    var statusEl = document.getElementById(trackId + '-status');

    if (isPlaying) {
      if (btnTxt) btnTxt.textContent = 'STOP PREVIEW';
      if (btn) btn.innerHTML = '&#9632; <span id="' + trackId + '-btn-text">STOP PREVIEW</span>';
      if (wave) { wave.style.opacity = '1'; wave.classList.add('motus-wave--playing'); }
      if (statusEl) statusEl.textContent = 'NOW PLAYING...';
    } else {
      if (btnTxt) btnTxt.textContent = 'AUDITION PREVIEW';
      if (btn) btn.innerHTML = '&#9654; <span id="' + trackId + '-btn-text">AUDITION PREVIEW</span>';
      if (wave) { wave.style.opacity = '0.5'; wave.classList.remove('motus-wave--playing'); }
      if (statusEl) {
        var cfg = TRACK_PREVIEWS[trackId];
        if (cfg) statusEl.textContent = cfg.bpm + ' BPM';
      }
    }
  }

  function playProceduralPreview(trackId) {
    var config = TRACK_PREVIEWS[trackId] || { bpm: 120, type: 'synthwave' };
    var intervalMs = (60 / config.bpm) * 1000 / 2;
    var step = 0;

    previewInterval = setInterval(function () {
      var time = audioCtx.currentTime;
      if (config.type === 'trap') {
        if (step % 2 === 0) {
          var freqs = [220, 261.63, 311.13, 196];
          playPluck(freqs[step % 4], time, 0.15);
        }
        if (step % 4 === 0) playKick(time);
        if (step % 2 === 1) playHat(time);
      } else if (config.type === 'synthwave') {
        if (step % 4 === 0) {
          playPluck(130.81, time, 0.3, 'sawtooth');
          playPluck(196.00, time, 0.3, 'sawtooth');
        }
        if (step % 8 === 0) playKick(time);
      } else if (config.type === 'drums') {
        if (step % 4 === 0) playKick(time);
        if (step % 2 === 1) playHat(time);
        if (step % 8 === 4) playSnare(time);
      } else {
        // cyberpunk
        if (step % 2 === 0) playPluck(146.83, time, 0.2, 'sawtooth');
        if (step % 4 === 0) playKick(time);
        if (step % 2 === 1) playHat(time);
      }
      step = (step + 1) % 16;
    }, intervalMs);
  }

  function playPluck(freq, time, duration, type) {
    type = type || 'sine';
    var osc  = audioCtx.createOscillator();
    var gain = audioCtx.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(freq, time);
    gain.gain.setValueAtTime(0.15, time);
    gain.gain.exponentialRampToValueAtTime(0.001, time + duration);
    osc.connect(gain);
    gain.connect(audioCtx.destination);
    osc.start(time);
    osc.stop(time + duration);
  }

  function playKick(time) {
    var osc  = audioCtx.createOscillator();
    var gain = audioCtx.createGain();
    osc.frequency.setValueAtTime(120, time);
    osc.frequency.exponentialRampToValueAtTime(0.01, time + 0.2);
    gain.gain.setValueAtTime(0.3, time);
    gain.gain.exponentialRampToValueAtTime(0.001, time + 0.2);
    osc.connect(gain);
    gain.connect(audioCtx.destination);
    osc.start(time);
    osc.stop(time + 0.2);
  }

  function playHat(time) {
    var osc  = audioCtx.createOscillator();
    var gain = audioCtx.createGain();
    osc.type = 'triangle';
    osc.frequency.setValueAtTime(8000, time);
    gain.gain.setValueAtTime(0.05, time);
    gain.gain.exponentialRampToValueAtTime(0.001, time + 0.05);
    osc.connect(gain);
    gain.connect(audioCtx.destination);
    osc.start(time);
    osc.stop(time + 0.05);
  }

  function playSnare(time) {
    var bufferSize = audioCtx.sampleRate * 0.1;
    var buffer = audioCtx.createBuffer(1, bufferSize, audioCtx.sampleRate);
    var data   = buffer.getChannelData(0);
    for (var i = 0; i < bufferSize; i++) data[i] = (Math.random() * 2 - 1);
    var source = audioCtx.createBufferSource();
    source.buffer = buffer;
    var gain = audioCtx.createGain();
    gain.gain.setValueAtTime(0.12, time);
    gain.gain.exponentialRampToValueAtTime(0.001, time + 0.1);
    source.connect(gain);
    gain.connect(audioCtx.destination);
    source.start(time);
    source.stop(time + 0.1);
  }

})();
